module.exports = __webpack_public_path__ + "img/background-mobile.c8562145.png";